import classnames from 'classnames/bind';

import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Card = ({
  className = '',
  children,
  onClick,
}: {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  const cardClass = cx({
    card: true,
    [className]: true,
  });
  return (
    <div className={cardClass} onClick={onClick}>
      {children}
    </div>
  );
};

export default Card;
